
/* ===== 통합 결과 KRDS 요약 (시안 6) — 기존 renderResult 무수정 ===== */
(function(){
  var R6={R:{n:'현실형',l:'R'},I:{n:'탐구형',l:'I'},A:{n:'예술형',l:'A'},
          S:{n:'사회형',l:'S'},E:{n:'진취형',l:'E'},C:{n:'관습형',l:'C'}};
  /* Big5 → 형용사 (높음/낮음) */
  var B5W={
    E:{hi:'사교적인',lo:'차분한'}, A:{hi:'공감하는',lo:'주관이 뚜렷한'},
    C:{hi:'꼼꼼한',lo:'유연한'},  O:{hi:'호기심 많은',lo:'현실적인'},
    N:{hi:'섬세한',lo:'안정적인'}
  };
  function ico(kind){
    var m={
      person:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7"/></svg>',
      compass:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2 5.5-5.5 2 2-5.5z"/></svg>',
      chat:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-5.5A8 8 0 0 1 11 4h2a8 8 0 0 1 8 8z"/></svg>',
      spark:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6.3 6.3l2.8 2.8M14.9 14.9l2.8 2.8M17.7 6.3l-2.8 2.8M9.1 14.9l-2.8 2.8"/></svg>',
      qr:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3zM20 14h1M14 20h3M20 18v3"/></svg>',
      home:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m3 10 9-7 9 7v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 21v-7h6v7"/></svg>'
    };
    return m[kind]||'';
  }
  function row(id,tone,icon,title,words,target){
    return '<button type="button" class="pia-sum pia-sum--'+tone+'" data-act="piaResultJump" data-arg="'+target+'">'
      +'<span class="pia-sum__ic" aria-hidden="true">'+ico(icon)+'</span>'
      +'<span class="pia-sum__tx"><span class="pia-sum__t">'+title+'</span>'
      +'<span class="pia-sum__w">'+(words||((window.aipiaCurrentLang==='en')?'Preparing assessment data':'검사 데이터 준비 중'))+'</span></span>'
      +'<span class="pia-sum__more">'+((window.aipiaCurrentLang==='en')?'View details':'자세히 보기')+'</span>'
      +'<span class="pia-sum__ar" aria-hidden="true">›</span></button>';
  }

  window.piaResultJump=function(sel){
    try{
      var t=document.querySelector(sel);
      if(!t){ if(window.openFullReport) openFullReport(); return; }
      t.classList.remove('hidden');
      t.scrollIntoView({behavior:'smooth',block:'start'});
      t.setAttribute('tabindex','-1'); t.focus({preventScroll:true});
    }catch(e){ if(window.console) console.error('결과 이동 실패:', e); }
  };

  /* 결과지 첫 화면 문구를 열람 대상에 맞춘다.
     예전에는 aud=teacher 로 열어도 첫 화면만 학생에게 말하는 투("~님의 통합 결과",
     "분석했어요")여서, 교사·학부모가 보기에 어색하고 상세 영역과 어조가 어긋났다. */
  function _aud(){
    try{ return (typeof currentAudience!=='undefined' && currentAudience) ? currentAudience : 'student'; }
    catch(e){ return 'student'; }
  }
  function _headTitle(nm){
    var a=_aud(), who = nm ? _escHtml(nm) : '';
    /* 이름 자체에 '학생'이 붙어 있는 경우가 있어(예: 샘플 학생) 덧붙이지 않는다 */
    var en=(window.aipiaCurrentLang==='en');
    if(en){
      if(a==='teacher') return (who?who+'\'s ':'')+'Results — For Teachers';
      if(a==='parent')  return (who?who+'\'s ':'')+'Results — For Parents';
      return (who?who+'\'s ':'')+'Integrated Results';
    }
    if(a==='teacher') return (who?who+' ':'')+'결과 — 선생님용';
    if(a==='parent')  return (who?who+' ':'')+'결과 — 학부모용';
    return (who?who+'님의 ':'')+'통합 결과';
  }
  function _headSub(){
    var a=_aud();
    var en=(window.aipiaCurrentLang==='en');
    if(en){
      if(a==='teacher') return 'Organized with evidence you can use for guidance, counseling, and parent conferences.';
      if(a==='parent')  return 'Organized to help you understand your child\'s tendencies and support them at home.';
      return 'Combining AI conversation, personality, and career interests into one analysis.';
    }
    if(a==='teacher') return '생활지도·상담·학부모 면담에 쓸 수 있도록 근거 중심으로 정리했습니다.';
    if(a==='parent')  return '자녀의 성향을 이해하고 가정에서 도울 방법을 중심으로 정리했습니다.';
    return 'AI 대화, 성격, 진로 흥미를 종합해 분석했어요.';
  }
  window.piaResultHead=function(){
    try{
      var host=document.getElementById('pia-result-head'); if(!host) return;
      var emp=document.getElementById('result-empty');
      if(emp && !emp.classList.contains('hidden')){ host.innerHTML=''; return; }

      var s=(typeof state!=='undefined'&&state)?state:(window.state||{});
      var rr=(s.results||{});
      var b5=(rr.big5||{}).scores, ri=(rr.riasec||{}).scores, cv=(rr.conv||{}).dims||{};
      if(!b5){ host.innerHTML=''; return; }

      var nm=((s.profile||{}).name)||s.studentId||'';
      var tDesc=(document.getElementById('hero-desc')||{}).textContent||'';
      var tName=(document.getElementById('hero-type')||{}).textContent||'';

      /* ① 나의 성격 — Big5 상위 3 형용사 */
      var pw=Object.keys(B5W).map(function(k){
        var v=Number(b5[k])||50;
        return {w: v>=50?B5W[k].hi:B5W[k].lo, d: Math.abs(v-50)};
      }).sort(function(a,b){return b.d-a.d;}).slice(0,3).map(function(o){return o.w;}).join(' · ');

      /* ② 진로 흥미 — RIASEC TOP3 */
      var iw='';
      if(ri){
        iw=Object.keys(R6).map(function(k){return {k:k,v:Number(ri[k])||0};})
            .sort(function(a,b){return b.v-a.v;}).slice(0,3)
            .map(function(o){return R6[o.k].n+' '+R6[o.k].l;}).join(' · ');
      }

      /* ③ AI가 발견한 나 — 대화 성향 TOP3 */
      var aw=Object.keys(cv).map(function(k){return {k:k,v:Number(cv[k])||0};})
              .filter(function(o){return o.v>0;})
              .sort(function(a,b){return b.v-a.v;}).slice(0,3)
              .map(function(o){return o.k;}).join(' · ');

      /* ④ 추천 진로 TOP3 */
      var jobs='', cw=document.getElementById('careers');
      if(cw){
        var seen={},uniq=[];
        [].slice.call(cw.children).forEach(function(row){
          var stars='', name='';
          [].slice.call(row.querySelectorAll('span,li,strong,b')).forEach(function(e){
            if(e.children.length) return;
            var t=(e.textContent||'').trim().replace(/\s+/g,' ');
            if(!t) return;
            if(/^[\u2605\u2606\u002A\s]+$/.test(t)){ if(!stars) stars=t; return; }  /* 별점만 있는 칸은 이름이 아님 */
            if(!name && t.length>1 && t.length<28) name=t;
          });
          if(name && !seen[name]){ seen[name]=1; uniq.push({n:name, s:stars}); }
        });
        uniq=uniq.slice(0,3);
        if(uniq.length){
          jobs='<section class="pia-sec pia-sec--qa"><h2 class="pia-h2" style="margin-bottom:var(--pia-s3)">'+_T('추천 진로 TOP 3','Top 3 Recommended Careers')+'</h2>'
            +'<ol class="pia-top3">'+uniq.map(function(o,i){
              return '<li class="pia-top3__i"><span class="pia-top3__r">0'+(i+1)+'</span>'
                +'<span class="pia-top3__t">'+o.n+'</span>'
                +(o.s?'<span class="pia-top3__st" aria-label="적합도">'+o.s+'</span>':'')
                +'<span class="pia-top3__ar" aria-hidden="true">›</span></li>';
            }).join('')+'</ol></section>';
        }
      }

      host.innerHTML='<div class="pia">'
        +'<button type="button" class="pia-back" data-act="showView" data-arg="home">'
        +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="width:1em;height:1em"><path d="M15 18 9 12l6-6"/></svg>'+_T('검사 홈','Assessment Home')+'</button>'
        +'<section class="pia-rhero">'
          +'<div class="pia-rhero__tx">'
            +'<h2 class="pia-h1">'+_headTitle(nm)+'</h2>'
            +'<p class="pia-bodyL pia-muted" style="margin-top:var(--pia-s2)">'+_headSub()+'</p>'
          +'</div>'
          +'<div class="pia-rhero__bot">'+PIA.botImg('wave','예담 톡 캐릭터')+'</div>'
        +'</section>'
        +'<section class="pia-sec pia-ai">'
          +'<div class="pia-ai__ic" aria-hidden="true">'+ico('spark')+'</div>'
          +'<div class="pia-ai__tx">'
            +'<span class="pia-ai__lab">'+_T('AI 종합 분석','AI Comprehensive Analysis')+'</span>'
            +'<p class="pia-ai__d">'+(tDesc||tName||_T('검사 결과를 분석했어요.','Your results have been analyzed.'))+'</p>'
          +'</div>'
        +'</section>'
        +'<div class="pia-sums">'
          +row('p','green','person',_T('나의 성격','My Personality'),pw,'#chart-big5-wrap')
          +row('i','purple','compass',_T('진로 흥미','Career Interests'),iw,'#chart-riasec-wrap')
          +row('a','orange','chat',_T('AI가 발견한 나','What AI Discovered About Me'),aw,'#result-qa')
        +'</div>'
        +jobs
        +'<div style="margin-bottom:var(--pia-s3)">'
        +'<button type="button" class="pia-btn pia-btn--primary pia-btn--cta" data-act="piaResultJump" data-arg="#chart-big5-wrap">'+_T('상세 결과 보기','View Detailed Results')+'<span class="pia-btn__ar" aria-hidden="true">›</span></button>'
        +'<div style="height:var(--pia-s2)"></div>'
        +'<button type="button" class="pia-btn pia-btn--secondary" data-act="?showShareModal">'
        +'<span class="pia-btn__ic" aria-hidden="true">'+ico('qr')+'</span>'+_T('QR로 결과 가져가기','Get Results via QR')+'</button>'
        +'</div>'
        +'<div class="pia-rfoot"><button type="button" data-act="showView" data-arg="home">'
        +'<span aria-hidden="true">'+ico('home')+'</span>'+_T('처음으로','Back to Home')+'</button></div>'
        +'<p class="pia-cap" style="margin:var(--pia-s3) 0 var(--pia-s5)">'+_T('이 결과지는 선별·참고용이며 의료적 진단이 아닙니다.','This report is for screening and reference only, and is not a medical diagnosis.')+'</p>'
        +'</div>';
    }catch(e){ if(window.console) console.error('piaResultHead 실패:', e); }
  };

  function wrap(){
    if(typeof window.renderResult!=='function' || window.renderResult._piaWrapped) return false;
    var o=window.renderResult;
    var w=function(){
      var r;
      try{ r=o.apply(this,arguments); }
      catch(e){ if(window.console) console.error('renderResult 오류:', e); }
      finally{ try{ window.piaResultHead(); }catch(e2){ if(window.console) console.error('piaResultHead 오류:', e2); } }
      return r;
    };
    w._piaWrapped=true; window.renderResult=w; return true;
  }
  if(!wrap()){ var t=setInterval(function(){ if(wrap()) clearInterval(t); },200); setTimeout(function(){clearInterval(t);},6000); }
})();

